export type SetupTerminalRequest = {
  title: string
  agentId: string | null
  message: string
}

const EVENT_NAME = "openclaw:setup-terminal"

export function dispatchSetupTerminal(req: SetupTerminalRequest): void {
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: req }))
}

export function onSetupTerminal(
  callback: (req: SetupTerminalRequest) => void
): () => void {
  const handler = (e: Event) => {
    callback((e as CustomEvent<SetupTerminalRequest>).detail)
  }
  window.addEventListener(EVENT_NAME, handler)
  return () => window.removeEventListener(EVENT_NAME, handler)
}
